<template>
  <input
    aria-label="Поле ввода количества"
    type="text"
    v-bind:disabled="disabled"
    v-model="count"
    v-on:blur="onBlur"
    v-on:focus="onFocus"
    v-on:input="onInput"
  />
</template>

<script>

/**
 * @description Название события ввода
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

/**
 * @description Название события потери фокуса
 * @type {string}
 */
const NAME_EVENT_BLUR = 'blur';

/**
 * Компонент ввода количества.
 * @type {Vue}
 */
export default {
  data() {
    return {
      count: this.value,
    };
  },
  methods: {
    /**
     * @description Обработать потерю фокуса.
     * @returns {void}
     */
    onBlur() {
      if (this.count === 0 || this.count === '') {
        this.count = 1;
      }
      this.$emit(NAME_EVENT_BLUR, this.count);
    },
    /**
     * @description Обработать ввод.
     * @returns {void}
     */
    onInput() {
      this.formattingCount();
      this.$emit(NAME_EVENT_INPUT, this.count);
    },
    /**
     * @description Обработать фокус.
     * @returns {void}
     */
    onFocus() {
      if (this.count === 0) {
        this.count = '';
      }
    },
    /**
     * @description Форматирование количества.
     * @returns {void}
     */
    formattingCount() {
      const regexp = /[^\d]/g;
      const value = this.count.replace(regexp, '');
      if (value === '') {
        this.count = 0;
        return;
      }
      const format = /^[\d]{0,3}/g;
      const [result] = format.exec(value) || [this.value];
      this.count = Math.max(Number(result), 1);
    },
  },
  name: 'InputCount',
  props: {
    /**
     * Деактивирован.
     * @type {boolean}
     */
    disabled: { default: () => false, type: Boolean },
    /**
     * Значение.
     * @type {number}
     */
    value: { type: Number, required: true },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.count = newValue;
      }
    },
  },
};
</script>

<style>
</style>
